import React from 'react';
import { MainLayout } from '@layouts';
import { withUser } from '@modules/auth';
import { DistributorsPage } from '@sections/Distributors-Page';
import { getDistributorsData } from '@modules/get-data';

const Distributors = (cards) => {
  return <DistributorsPage data={cards} />;
};

Distributors.getLayout = (page) => {
  const { translations } = page.props;

  return (
    <MainLayout
      title={translations.t(`site.distributors.meta.title`)}
      description={translations.t(`site.distributors.meta.description`)}>
      {page}
    </MainLayout>
  );
};

Distributors.getInitialProps = async ({ store }) => {
  const { dispatch } = store;
  const cards = await dispatch(getDistributorsData());

  return cards;
};

export default withUser(Distributors);
